<template>
  <div class="order">
    <div class="order-title">订单列表</div>

    <div class="orderFrom">
      <div class="order-head">
        <div class="orderHead-item">
          <span>订单编号</span>
          <div class="el-input-div">
            <el-input
              placeholder="请输入订单编号"
              v-model="oidStr"
              clearable
              @clear="getClearOid"
            >
            </el-input>
          </div>
        </div>
        <div class="orderHead-item">
          <span>付款金额</span>
          <div class="el-input-div">
            <el-input
              placeholder="请输入付款金额"
              v-model="moneyStr"
              clearable
              @clear="getClearMoney"
            >
              <span slot="prefix" class="el-input-item">¥</span>
            </el-input>
          </div>
        </div>
        <div class="orderHead-item">
          <span>状态</span>
          <div class="el-input-div">
            <el-select v-model="stateStr" placeholder="请选择状态">
              <el-option
                v-for="item in stateList"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="orderHead-item">
          <span>时间</span>
          <div class="el-input-div">
            <el-date-picker
              class="el-date-picker"
              v-model="pickerArr"
              type="daterange"
              range-separator="—"
              start-placeholder="开始"
              end-placeholder="结束"
              clearable
              @change="clearablePick"
            >
            </el-date-picker>
          </div>
        </div>

        <div class="search-box" @click="btnSearch">搜索</div>
      </div>

      <el-table
        :data="orderList"
        stripe
        style="width: 100%"
        v-loading="tableLoading"
      >
        <el-table-column prop="oid" label="订单编号" min-width="100">
        </el-table-column>
        <el-table-column label="金额" min-width="100">
          <template slot-scope="scope">
            <span>¥ {{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100">
          <template slot-scope="scope">
            <span
              :style="
                scope.row.stateText === '未付款'
                  ? 'color:#FF4242'
                  : scope.row.stateText === '已失效'
                  ? 'color:#999999'
                  : ''
              "
              >{{ scope.row.stateText }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="pay_time" label="时间" min-width="100">
        </el-table-column>
        <el-table-column prop="address" label="操作" min-width="100">
          <template slot-scope="scope">
            <div class="orderDetail" @click="getDetail(scope.row)">
              <i
                class="el-icon-s-order"
                style="color: #327cfc; font-size: 16px; margin-right: 3px"
              ></i>
              <span>订单详情</span>
            </div>

            <div
              class="orderDetele"
              v-if="scope.row.stateText === '已失效'"
              @click="getDelete(scope.row.oid, scope.$index)"
            >
              <i
                class="el-icon-delete"
                style="color: #ff4242; font-size: 16px; margin-right: 3px"
              ></i>
              <span>删除</span>
            </div>

            <div
              class="orderPayment"
              v-if="scope.row.stateText === '未付款'"
              @click="getPayment(scope.row.oid)"
            >
              <i
                class="el-icon-s-finance"
                style="color: #327cfc; font-size: 16px; margin-right: 3px"
              ></i>
              <span>付款</span>
            </div>

            <div
              class="orderDetele"
              v-if="scope.row.stateText === '未付款'"
              @click="getCancellation(scope.row.oid, scope.$index)"
            >
              <i
                class="el-icon-circle-close"
                style="color: #ff4242; font-size: 16px; margin-right: 3px"
              ></i>
              <span>取消订单</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 页面分页设置 -->
    <div class="block">
      <el-pagination
        :page-size="20"
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <OrderPop v-if="orderDetail" :Detail="orderDetail" @guanbiPop="guanbiPop" />
  </div>
</template>

<script>
import request from "../utils/request";

import OrderPop from "../modules/orderPop";

export default {
  components: {
    OrderPop,
  },
  data() {
    return {
      orderList: [],
      stateList: [],
      stateStr: "all",
      oidStr: "",
      moneyStr: "",
      pickerStr: "",
      pickerArr: [],
      total: 0,
      orderDetail: null,
      tableLoading: true,
      pages: 1,
    };
  },

  mounted: function () {
    this.init();
  },

  methods: {
    guanbiPop: function (evnet) {
      console.log(evnet);

      this.orderDetail = null;
    },

    getSearch: function () {
      this.tableLoading = true;
      request({
        url: `/api/order/list?page=${this.pages}&oid=${this.oidStr}&price=${this.moneyStr}&state=${this.stateStr}&createTime=${this.pickerStr}`,
        method: "GET",
      }).then((res) => {
        this.total = res.data.total;
        this.orderList = res.data.orderList;
        this.stateList = res.data.stateList;
        this.tableLoading = false;
      });
    },

    // 页数发生改变时触发的方法
    handleCurrentChange: function (value) {
      this.pages = value;
      this.getSearch();
    },

    // 搜索
    btnSearch: function () {
      this.getSearch();
    },

    getdate(now) {
      if (now) {
        let y = now.getFullYear();
        let m = now.getMonth() + 1;
        let d = now.getDate();
        return (
          y +
          "-" +
          (m < 10 ? "0" + m : m) +
          "-" +
          (d < 10 ? "0" + d : d) +
          " " +
          now.toTimeString().substr(0, 8)
        );
      } else {
        return null;
      }
    },

    init: function () {
      request({
        url: "/api/order/list",
        method: "GET",
      }).then((res) => {
        this.total = res.data.total;
        this.orderList = res.data.orderList;
        this.stateList = res.data.stateList;
        this.tableLoading = false;
      });
    },

    // 订单输入框清除内容事件
    getClearOid: function () {
      this.tableLoading = true;
      this.getSearch();
    },
    // 应付金额清除
    getClearMoney: function () {
      this.tableLoading = true;
      this.getSearch();
    },

    clearablePick: function (value) {
      if (value === null) {
        this.getSearch();
      } else {
        this.pickerStr = [
          this.getdate(this.pickerArr[0]),
          this.getdate(this.pickerArr[1]),
        ].join(" - "); // 时间搜索格式转换
      }
    },

    // 显示详情
    getDetail: function (data) {
      this.orderDetail = data;
    },

    // 删除订单
    getDelete: function (oid, i) {
      this.$confirm("此操作将永久删除订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/api/order/delOrder",
          method: "POST",
          data: {
            oid: [oid],
          },
        }).then((res) => {
          this.orderList.splice(i, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });
    },

    // 取消订单
    getCancellation: function (oid, i) {
      this.$confirm("此操作将取消订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/api/order/cancelOrder",
          method: "POST",
          data: {
            oid: [oid],
          },
        }).then((res) => {
          this.orderList[i].stateText = "已失效";
          this.$message({
            type: "success",
            message: "取消成功!",
          });
        });
      });
    },

    // 付款
    getPayment: function (id) {
      let openURL = `/api/redirect/order/${id}`;
      window.open(openURL);
    },
  },
};
</script>
 


<style lang="scss" scoped>
.block {
  text-align: center;
  margin-top: 30px;
  .el-pager li.active {
    background: #1890ff;
    color: #fff !important;
  }
  .el-pagination__sizes {
    margin: 5px;
    float: right;
    font-weight: 400;
    color: #606266;
  }
  .el-pagination .el-select .el-input .el-input__inner {
    padding-right: 30px;
    border-radius: 7px;
    background: #1890ff;
    height: 35px;

    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  }
  .el-pagination__sizes .el-input .el-input__inner {
    font-size: 14px;
    padding-left: 8px;
    color: #fff;
    font-family: Microsoft YaHei;
  }
}

.orderHead-item {
  display: inline-block;
  margin-right: 30px;
  margin-bottom: 20px;
}

.el-input-div {
  display: inline-block;
  width: 210px;
  margin-left: 9px;
  .el-input-item {
    line-height: 40px;
    text-align: center;
    padding: 0 10px;
  }

  .el-date-picker {
    width: 210px;
  }
}

.order-title {
  padding: 24px 0;
  width: 100%;
  color: #2d3748;
  font-size: 18px;
  font-weight: 400;
  line-height: 18px;
}

.orderFrom {
  width: 100%;
  min-height: 829px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 26px;
  overflow: hidden;
  padding: 0 20px;
}

.orderDetail {
  display: inline-block;
  color: #327cfc;
  font-size: 14px;
  margin-right: 30px;
  cursor: pointer;
}

.orderDetele {
  display: inline-block;
  color: #ff4242;
  font-size: 14px;
  cursor: pointer;
}

.orderPayment {
  display: inline-block;
  color: #327cfc;
  font-size: 14px;
  margin-right: 30px;
  cursor: pointer;
}

.order-head {
  padding: 20px 0;
}

.search-box {
  display: inline-block;
  width: 64px;
  height: 37px;
  background: #1890ff;
  opacity: 1;
  border-radius: 8px;
  color: #fff;
  line-height: 37px;
  text-align: center;
  cursor: pointer;
}
.search-box:active {
  background: #63adf3;
}
</style>
 